// src/data/mockRooms.js
// Centralized room data - will be replaced with database/API
//
// Room States:
// - 'scheduled' = upcoming, not started
// - 'live' = currently streaming
// - 'ended' = finished
//
// Rooms reference creators by creatorId

export const mockRooms = [
  // ============================================
  // LIVE ROOMS
  // ============================================
  {
    id: "room-cg-1",
    creatorId: 2, // Crypto Guru
    title: "DeFi Alpha: Yield Strategy Live",
    description: "Join me as I break down the latest yield farming strategies and share alpha on upcoming DeFi protocols. We'll cover the hottest opportunities and I'll share my current positions.",
    thumbnail: null, // Falls back to creator.liveImage
    status: "live",
    viewers: 1243,
    startedAt: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
    scheduledTime: null,
    scheduledAt: null,
    endedAt: null,
    streamUrl: "https://www.youtube.com/embed/jfKfPfyJRdk?autoplay=1&mute=1", // lofi girl for demo
    accessTier: "holder",
    ticketPrice: 0.08,
    minTokens: 100,
    seatsLeft: null,
    totalSeats: null,
    tags: ["DeFi", "Yield Farming", "Alpha"],
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-at-1",
    creatorId: 4, // AlgoTrader
    title: "AI Scalps: Latency-Arb Session",
    description: "Live algorithmic trading session focusing on latency arbitrage opportunities across DEXs. Watch the bots in action and learn the strategies.",
    thumbnail: null,
    status: "live",
    viewers: 879,
    startedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    scheduledTime: null,
    scheduledAt: null,
    endedAt: null,
    streamUrl: null, // No stream URL - will show thumbnail
    accessTier: "holder",
    ticketPrice: 0.05,
    minTokens: 50,
    seatsLeft: null,
    totalSeats: null,
    tags: ["Algo Trading", "MEV", "Arbitrage"],
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-tt-1",
    creatorId: 14, // TokenTalk
    title: "Macro Hour: BTC Dominance Discussion",
    description: "Weekly macro analysis covering Bitcoin dominance trends and what they mean for altcoins. Bringing on special guests to debate the market direction.",
    thumbnail: null,
    status: "live",
    viewers: 990,
    startedAt: new Date(Date.now() - 60 * 60 * 1000).toISOString(),
    scheduledTime: null,
    scheduledAt: null,
    endedAt: null,
    streamUrl: null,
    accessTier: "free",
    ticketPrice: null,
    minTokens: 0,
    seatsLeft: null,
    totalSeats: null,
    tags: ["Macro", "Bitcoin", "Analysis"],
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-as-1",
    creatorId: 7, // AlphaSeeker
    title: "Meme Radar: Pre-Viral Hunt",
    description: "Scanning for the next meme coin before it goes viral. Real-time research and analysis. Join me as I share my screening process live.",
    thumbnail: null,
    status: "live",
    viewers: 2310,
    startedAt: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    scheduledTime: null,
    scheduledAt: null,
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.1,
    minTokens: 200,
    seatsLeft: null,
    totalSeats: null,
    tags: ["Memecoins", "Research", "Alpha"],
    createdAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
  },

  // ============================================
  // SCHEDULED ROOMS (Later)
  // ============================================
  {
    id: "room-mt-1",
    creatorId: 3, // Maya Tokens
    title: "Launch AMA: Community Q&A",
    description: "Ask me anything about token launches, exchange listings, and market making strategies. Open floor for all your questions.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Tomorrow 8PM",
    scheduledAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.05,
    minTokens: 50,
    seatsLeft: 45,
    totalSeats: 100,
    tags: ["AMA", "Token Launch", "Q&A"],
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-dq-1",
    creatorId: 5, // DeFi Queen
    title: "NFT Floor Rescue Strategy",
    description: "Learn how to recover value from underwater NFT positions and maximize your exit strategy. Real examples from my own portfolio.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Tonight 9PM",
    scheduledAt: new Date(Date.now() + 4 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "premium",
    ticketPrice: 0.15,
    minTokens: 500,
    seatsLeft: 8,
    totalSeats: 50,
    tags: ["NFT", "Strategy", "Recovery"],
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-ee-1",
    creatorId: 15, // Ethan Edge
    title: "On-Chain Options: Live Greeks Analysis",
    description: "Deep dive into on-chain options protocols with live Greeks calculations and trade setups. Perfect for intermediate to advanced traders.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Fri 7PM",
    scheduledAt: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.08,
    minTokens: 100,
    seatsLeft: 23,
    totalSeats: 75,
    tags: ["Options", "Greeks", "Advanced"],
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-tm-1",
    creatorId: 6, // TradeMaster
    title: "Perp Ladder: Live Scalping Session",
    description: "Watch me scalp perpetual futures live with real-time commentary on entries and exits. Learn my exact process.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Tomorrow 3PM",
    scheduledAt: new Date(Date.now() + 20 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "premium",
    ticketPrice: 0.2,
    minTokens: 1000,
    seatsLeft: 12,
    totalSeats: 100,
    tags: ["Scalping", "Perps", "Live Trading"],
    createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-cv-1",
    creatorId: 17, // CryptoViper
    title: "Solana MEV: Sandwich Watch",
    description: "Monitoring Solana MEV activity and discussing protection strategies for traders. Learn to protect your trades.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Sat 2PM",
    scheduledAt: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.08,
    minTokens: 250,
    seatsLeft: 0, // Sold out
    totalSeats: 30,
    tags: ["Solana", "MEV", "Security"],
    createdAt: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
  },

  // Additional scheduled rooms for LIVE creators (so they have upcoming rooms too)
  {
    id: "room-cg-2",
    creatorId: 2, // Crypto Guru (currently live)
    title: "Weekly Alpha Drop: Top 5 Picks",
    description: "My weekly breakdown of the top 5 tokens I'm watching and why they could pump. Full research and analysis shared.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Wed 7PM",
    scheduledAt: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.08,
    minTokens: 100,
    seatsLeft: 67,
    totalSeats: 150,
    tags: ["Alpha", "Research", "Weekly"],
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-cg-3",
    creatorId: 2, // Crypto Guru (currently live)
    title: "Portfolio Review: Community Edition",
    description: "Submit your portfolio for live review and feedback. Limited spots available!",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Fri 6PM",
    scheduledAt: new Date(Date.now() + 4 * 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "premium",
    ticketPrice: 0.25,
    minTokens: 500,
    seatsLeft: 15,
    totalSeats: 25,
    tags: ["Portfolio", "Review", "Premium"],
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-at-2",
    creatorId: 4, // AlgoTrader (currently live)
    title: "Bot Building Workshop",
    description: "Learn to build your own trading bot from scratch. Beginner friendly session with code walkthrough.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Thu 4PM",
    scheduledAt: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.1,
    minTokens: 50,
    seatsLeft: 34,
    totalSeats: 80,
    tags: ["Workshop", "Bots", "Coding"],
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-tt-2",
    creatorId: 14, // TokenTalk (currently live)
    title: "Founder Interview: Secret Project Alpha",
    description: "Exclusive interview with the founder of an upcoming L2. First look at unreleased info.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Sun 5PM",
    scheduledAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "free",
    ticketPrice: null,
    minTokens: 0,
    seatsLeft: 189,
    totalSeats: 500,
    tags: ["Interview", "Exclusive", "L2"],
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-as-2",
    creatorId: 7, // AlphaSeeker (currently live)
    title: "Airdrop Hunting: Advanced Strategies",
    description: "My full airdrop farming setup revealed. Wallets, protocols, and timing strategies.",
    thumbnail: null,
    status: "scheduled",
    viewers: 0,
    startedAt: null,
    scheduledTime: "Tomorrow 10PM",
    scheduledAt: new Date(Date.now() + 28 * 60 * 60 * 1000).toISOString(),
    endedAt: null,
    streamUrl: null,
    accessTier: "holder",
    ticketPrice: 0.12,
    minTokens: 200,
    seatsLeft: 56,
    totalSeats: 120,
    tags: ["Airdrops", "Farming", "Strategy"],
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  },

  // ============================================
  // ENDED ROOMS (for history/recordings)
  // ============================================
  {
    id: "room-cg-0",
    creatorId: 2, // Crypto Guru
    title: "Weekly Market Wrap: What I'm Watching",
    description: "Recap of this week's market moves and what I'm keeping an eye on for next week.",
    thumbnail: null,
    status: "ended",
    viewers: 1856,
    startedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    scheduledTime: null,
    scheduledAt: null,
    endedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 90 * 60 * 1000).toISOString(),
    streamUrl: null,
    recordingUrl: "https://example.com/recording/room-cg-0",
    accessTier: "free",
    ticketPrice: null,
    minTokens: 0,
    seatsLeft: null,
    totalSeats: null,
    tags: ["Recap", "Weekly", "Analysis"],
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "room-at-0",
    creatorId: 4, // AlgoTrader
    title: "Intro to MEV: Understanding the Dark Forest",
    description: "Educational session on MEV basics and how to protect yourself.",
    thumbnail: null,
    status: "ended",
    viewers: 1245,
    startedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    scheduledTime: null,
    scheduledAt: null,
    endedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000 + 75 * 60 * 1000).toISOString(),
    streamUrl: null,
    recordingUrl: "https://example.com/recording/room-at-0",
    accessTier: "free",
    ticketPrice: null,
    minTokens: 0,
    seatsLeft: null,
    totalSeats: null,
    tags: ["MEV", "Education", "Security"],
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export default mockRooms;